module.exports = __webpack_public_path__ + "img/Schaduwdagen.bde6a13f.svg";